<template>
  <div id="appointment-setting">
    <!-- <vx-card> -->
      <!-- <h2 class="mb-6">ACTIVATE WEB BOOKING</h2> -->
      <div class="flex align-center">
        <vs-switch v-model="key_active" class="my-6" @click="updateActive"/>
        <span class="pl-5">Please press "Activate" only when you have completed all information in Setting, Services and Staff tabs.
           After you hit "Activate", all information will officially appear on your online booking and customers can start booking with your business.</span>
      </div>
    <!-- </vx-card> -->
  </div>
</template>
<script>
export default {
  name: 'vs-appointment-setting',
  data(){
    return{
      key_active: false,
      type_err: '',
      loaded_data_num: 0,
      action_type: ''
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = 'Get data';
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' Active Web Booking Failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout( ()=> {
        this.$vs.loading.close('#app > .con-vs-loading')
      }, 500);
    },
    updateActive(){
      const obj = {
        key: 'module.appointment.active',
        value: !this.key_active ? 1 : 0
      }
      this.action_type = 'Update';
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Update Active Web Booking Success',
          color:'success',
          position:'top-right'})
      }).catch(() => {
        this.$vs.notify({
          title:'Notification',
          text:'Update Active Web Booking Failed',
          color:'danger',
          position:'top-right'})
      })
    }
  },
  created(){
    const obj = {
      key: 'module.appointment.active'
    }
    this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
      this.loaded_data_num++;
      this.$emit('LoadDataComplete');
      let appointment = {};
      appointment = this.$store.getters["appSetting/keyStorage"];
      this.key_active = appointment.value == 1 ? true : false
    })
  }
}
</script>
